export default __webpack_public_path__ + "static/media/Anastasiia.246f0d95.png";